module.exports = __webpack_public_path__ + "static/media/CatchUp_logo_navbar.ad4ab84b.svg";